<template>
  <div class="field-group-edit-modal" v-if="showModal">
    <div class="modalHeader" style="border-radius: 9px 9px 0px 0px !important;">
      <span class="title">Edit Field Group</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div class="form-group">
        <label><b>Name:</b></label>
        <input type="text" class="form-control form-control-sm" v-model="editName">
      </div>
      <div class="form-group">
        <label><b>Label:</b></label>
        <input type="text" class="form-control form-control-sm" v-model="editLabel">
      </div>
      <div class="form-group">
        <label><b>Help Text:</b></label>
        <textarea class="form-control form-control-sm" v-model="editHelp" />
      </div>
      <div class="form-group">
        <label><b>Prefix:</b></label>
        <input type="text" class="form-control form-control-sm" v-model="prefix">
      </div>
      <div class="form-group">
        <label><b>Max Checked:</b></label>
        <input type="number" min="1" step="1" class="form-control form-control-sm" v-model="editMaxChecked" />
      </div>

      <table class="table table-sm table-bordered table-striped">
        <thead>
          <tr>
            <th>Field ID</th>
            <th>Actions</th>
            <th v-if="isAb === true">Yes/No</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(field, index) in fieldList" :key="index">
            <td>{{ field.translations.en.label }}</td>
            <td>
              <button class="btn btn-sm btn-light" @click="editFormField(index)">Edit Form Field</button>
              <button class="btn btn-sm btn-danger" @click="deleteFieldGroupField(index)">Remove</button>
              <i class="fas fa-angle-double-up" @click="move(index, true)"></i>
              <i class="fas fa-angle-double-down" @click="move(index, false)"></i>
            </td>
            <td v-if="isAb === true">
              <search-select
                v-if="Object.keys(fieldList).indexOf(index) === 0"
                :options="['Yes', 'No']"
                @input="setTypeA"
                v-model="typeA"
              />

              <search-select
                v-if="Object.keys(fieldList).indexOf(index) === 1"
                :options="['Yes', 'No']"
                @input="setTypeB"
                v-model="typeB"
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="button-box mr-0 float-right">
        <button class="btn btn-success" @click="saveEdit">Save</button>
        <button class="btn btn-secondary" @click="closeModal">Close</button>
      </div>

      <br>
      <br>

      <!-- Questionnaire Tags -->
      <div>
        <hr>

        <div>
          <questionnaire-tags
            :fieldGroupId="fieldId"
            :isGroupActions="isGroupActions"
          />
        </div>

        <div class="row modal-section" id="AbGroupWatchersGroup">\
          <hr>

          <div class="col-sm-12">
            <ab-group-watchers
              :isGroup="true"
              :fieldData="{ index: fieldId, watchers: watchers, tagVisible: tagVisible }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionnaireTags from '@/components/questionnaires/QuestionnaireTags'
import AbGroupWatchers from '@/components/questionnaires/ABGroupWatchers'

import SearchSelect from '../searchSelect/SearchSelect.vue'

export default {
  name: 'field-group-edit-modal',

  mounted () {
    let that = this
    this.$bus.on('fieldGroupEditModal', function (fieldId) {
      that.fieldId = fieldId
      const storeGroup = that.$store.state.templates[that.$store.state.currentTemplateName]['checkboxGroups'][fieldId]
      that.editName = storeGroup.name
      that.editLabel = storeGroup.title
      that.editHelp = storeGroup.desc
      that.editMaxChecked = that.$store.getters.fieldGroupMaxFields(storeGroup.fieldId)
      that.fieldList = storeGroup.fields
      that.prefix = storeGroup.prefix
      that.showModal = true
      that.watchers = storeGroup.watchers !== undefined ? storeGroup.watchers : []
      that.isAb = storeGroup.abQuestion
      that.tagVisible = storeGroup.tagVisible

      let showActions = false

      Object.keys(that.fieldList).forEach(field => {
        if (that.fieldList[field].type === 'checkbox') showActions = true
      })

      if (that.isAb === true) {
        that.typeA = that.fieldList[Object.keys(that.fieldList)[0]].typeAb
        that.typeB = that.fieldList[Object.keys(that.fieldList)[1]].typeAb
      }

      that.isGroupActions = showActions
    })

    document.addEventListener('keyup', this.keyCheck)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.keyCheck, false)

    this.$bus.$off('fieldGroupEditModal')
  },

  data () {
    return {
      fieldId: '',
      showModal: false,
      editName: '',
      editLabel: '',
      editHelp: '',
      editMaxChecked: 1,
      fieldList: [],
      isGroupActions: false,
      prefix: '',
      watchers: [],
      isAb: false,
      typeA: '',
      typeB: '',
      tagVisible: true
    }
  },

  components: {
    QuestionnaireTags,
    AbGroupWatchers,
    SearchSelect
  },

  methods: {
    setTypeA (e) {
      this.typeA = e

      if (e === 'Yes') this.typeB = 'No'
      else if (e === 'No') this.typeB = 'Yes'

      let listCheckboxes = JSON.parse(JSON.stringify(this.fieldList))

      listCheckboxes[Object.keys(this.fieldList)[0]].typeAb = this.typeA
      listCheckboxes[Object.keys(this.fieldList)[1]].typeAb = this.typeB

      this.$store.commit('editFieldGroup', {
        index: this.fieldId,
        checkboxes: listCheckboxes
      })
    },

    setTypeB (e) {
      this.typeB = e

      if (e === 'Yes') this.typeA = 'No'
      else if (e === 'No') this.typeA = 'Yes'

      let listCheckboxes = JSON.parse(JSON.stringify(this.fieldList))

      listCheckboxes[Object.keys(this.fieldList)[0]].typeAb = this.typeA
      listCheckboxes[Object.keys(this.fieldList)[1]].typeAb = this.typeB

      this.$store.commit('editFieldGroup', {
        index: this.fieldId,
        checkboxes: listCheckboxes
      })
    },

    deleteFieldGroupField (index) {
      this.$store.commit('deleteExistOnFieldGroups', index)
      this.$bus.emit('reloadQuestionnaire')
      this.$store.dispatch('saveTemplate')

      let list = []
      list = this.fieldList
      Object.keys(list).forEach(id => {
        if (id === index) delete list[id]
      })

      this.fieldList = Object.assign({}, this.fieldList, list)
      if (Object.keys(this.fieldList).length === 0) this.showModal = false
    },

    move (moveIndex, up) {
      let tmpContainer = {}
      let targetIndex = -1
      let keys = []
      keys = Object.keys(this.fieldList)

      for (let index = 0; index < keys.length; index++) {
        tmpContainer[index] = keys[index]
        if (moveIndex === keys[index]) targetIndex = index
      }

      if (targetIndex === -1) return
      if (up && targetIndex - 1 < 0) return
      if (!up && targetIndex + 1 > keys.length - 1) return
      let newTarget = up ? targetIndex - 1 : targetIndex + 1

      let tabOrderTarget = this.fieldList[moveIndex].tabOrder
      let tabOrderMove = this.fieldList[keys[newTarget]].tabOrder

      this.fieldList[moveIndex].tabOrder = tabOrderMove
      this.fieldList[keys[newTarget]].tabOrder = tabOrderTarget

      keys.splice((newTarget < 0 ? keys.length + newTarget : newTarget), 0, keys.splice(targetIndex, 1)[0])

      let newData = {}
      for (let index = 0; index < keys.length; index++) {
        const element = keys[index]
        newData[element] = JSON.parse(JSON.stringify(this.fieldList[element]))
      }

      this.fieldList = newData

      this.$bus.emit('moveFieldGroupField', {
        moveIndex,
        up
      })
    },

    keyCheck (evt) {
      if (evt.keyCode === 27) this.closeModal()
    },

    closeModal () {
      this.showModal = false
    },

    saveEdit () {
      this.$store.commit('editFieldGroup', {
        index: this.fieldId,
        name: this.editName,
        label: this.editLabel,
        help: this.editHelp,
        prefix: this.prefix,
        maxChecked: Number(this.editMaxChecked)
      })

      this.$store.dispatch('saveTemplate')
      this.$bus.emit('reloadQuestionnaire')

      this.showModal = false
    },

    editFormField (index) {
      this.$bus.emit('openFieldMenu', {
        id: index
      })
      this.showModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .field-group-edit-modal {
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    max-width: 1700px;
    min-height: 600px;
    max-height: 90%;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .modalBody {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: calc(100% - 37px);
      overflow-y: auto;
    }
  }

  .button-box {
    float: right;
    margin-right: 30px;
    margin-bottom: 15px;
    .btn {
      margin-left: 10px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/questionnaires/FieldGroupEditModal.vue